export default "__VITE_ASSET__Ht8lw6KJ__";